import './styles/css/index.scss';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { createRoot } from 'react-dom/client';

import App from './App';

async function startWorker() {
  const { worker } = await import('./mocks/browser');
  worker.start();
}

if (import.meta.env.VITE_APP_ENABLE_MSW === 'true') {
  startWorker();
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App />);
